import {Link, useNavigate,} from "react-router-dom";
import styles from './signUp.module.css'
import {useRef, useState} from "react";
import {UserAuth} from '../../context/AuthContext'
const SignUp = () => {
	const [email, setEmail] = useState();
	const [password, setPassword] = useState();
	const [error, setError] = useState();
	const emailRef = useRef();
	const passwordRef = useRef();
	const confirmPasswordRef = useRef();
	const {createUser} = UserAuth()
	const navigate = useNavigate()
	async function handelSubmit (e) {
		e.preventDefault()
		setEmail(emailRef.current.value)
		setPassword(passwordRef.current.value)
		if (password !== confirmPasswordRef.current.value) {
			setError('Password doesnt Match')
		}
		else {
			try
			{
				await createUser(email, password)
				navigate('../')
			}
			catch (e)
			{
				setError(e.message)
				console.log(error)
			}
		}
	}
  return (
	  <div className={styles.container}>
		  <div className={styles.card}>
			  <h1 className={styles.header}>Sign Up</h1>
			  <form className={styles.form} onSubmit={handelSubmit}>
				  <input ref={emailRef} type="email" placeholder="Email Id"/>
				  <input ref={passwordRef} type="password" placeholder="Password"/>
				  <input ref={confirmPasswordRef} type="password" placeholder="Re-Enter Password"/>
				  <button type="submit">Submit</button>
			  </form>
			  <div>Already Have account? <Link to="/logIn">Log In</Link></div>
		  </div>
	  </div>
  )
}

export default SignUp;